/* eslint eqeqeq: 0 */
import React, { useState, useEffect } from 'react'
import axios from 'axios';
import DataTable from 'react-data-table-component';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrashArrowUp } from "@fortawesome/free-solid-svg-icons";
import { Spinner } from 'react-bootstrap';
import Pengaturan from './components/pengaturan';
function ActiveConnection(){
    const [nuAktip, setNuAktip]=useState('');    
    const [loading, setLoading] = useState(false);
    const idRouter=localStorage.getItem('rtr');
    const [cari, setCari] = useState('');
    const [search, setSearch] = useState('');
    const [jmlNuaktif, setJmlNuaktif]=useState('0');
    const columns = [
        {
            name: 'User Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Alamat',
            selector: row => row.address,
            sortable: true,
        },
        {
            name: 'Profile',
            selector: row => row.profile,
            sortable: true,
        },
        {
            name: 'Comment',
            selector: row => row.comment,
            sortable: true,
        },
        {
            cell: (row) => <span onClick={()=>jadiHapus(row.id)} style={{cursor:'pointer'}} title="Hapus "><span style={{fontSize: 20}}><FontAwesomeIcon icon={faTrashArrowUp} /></span></span>,
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    //data-bs-toggle="modal" data-bs-target="#exampleModal"
    const jadiHapus = async (x) => {  
        let res='';
        let params = {id: x,router: idRouter};//new URLSearchParams([['cari',search],['router',idRouter]]);//
        await axios.get(Pengaturan['urlApi']+'deleteactive',{params})
        .then((response)=>{
            res=response.data;
        });
        if(res == '1') {
            fetchData();
        }
    }
    const fetchData = async () =>{        
        setLoading(true);
        const params = {cari: search,router: idRouter};//new URLSearchParams([['cari',search],['router',idRouter]]);//
        await axios.get(Pengaturan['urlApi']+'getactiveconnection',{params})
        .then((response)=>{
            setNuAktip(response.data)
            setJmlNuaktif(response.data.length)
        });
        setLoading(false);
    };
    useEffect(()=>{
        fetchData();
    },[search]);
    const isi=()=>{
        if(loading){
            return (
                <div className='row justify-content-center'><br />
                    <Spinner animation="border" role="status">
                        <span className="visually-hidden">Loading...</span>
                    </Spinner>
                </div>
            )
        }else{
            return(
            <div className='row justify-content-center'>                
                <div className='col-md-12'>
                <DataTable
                    columns={columns}
                    data={nuAktip}
                    pagination
                />
                </div>
            </div>
            )
        }
    }
    return(
        <>
        <div className='row'>
            <div className="col-md-4">
                    <strong>PPP - Active Connection ({jmlNuaktif})</strong>&nbsp;
            </div>
            <div className="col-md-4"></div>
            <div className='col-md-4'>
                    <input 
                        style={{width:'70%'}}
                        type='text' 
                        onChange={(e)=>{
                            if(e.target.value.length > 0){
                                setCari(e.target.value);
                            }else{
                                setSearch('');
                            } }} 
                        onKeyDown={event => {
                            if (event.key === 'Enter') {
                                setSearch(cari)
                            }
                          }}  />&nbsp;
                    <button className='btn btn-primary' onClick={()=>{setSearch(cari)}}>Cari</button>
            </div>
        </div>
            {isi()}
            <div className="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Modal title</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    
                    <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Batal</button>
                        <button type="button" onclick={()=>jadiHapus()}className="btn btn-danger">Hapus</button>
                    </div>
                    </div>
                </div>
            </div>
        </>
    );
}
export default ActiveConnection;